/**
 * Verification Exceptions
 *
 * Error codes and messages for the identity document verification feature.
 * Located in default/ because these are app-specific exceptions (not imported
 * from an external API). The fixtures/ folder is for exceptions from external
 * services like the platform API.
 *
 * Error code format: 4XXX for verification-related errors
 */

export const verificationExceptions: Record<string, string> = {
  V4000: "No fue posible autenticar el servicio de verificación",
  V4001:
    "No pudimos leer el archivo. Verifica que no esté dañado y vuelve a intentarlo.",
  V4002: "Formato no compatible. Usa PDF, JPG, JPEG, PNG o WebP.",
  V4003: "El archivo excede el límite de 20 MB.",
  V4004:
    "No pudimos procesar el documento en este momento. Inténtalo nuevamente.",
  V4005: "El servicio de verificación no está disponible temporalmente.",
  V4006: "La verificación tardó demasiado. Inténtalo nuevamente.",
  V4007: "El servicio de verificación devolvió una respuesta inválida.",
  V4008: "La imagen no es lo suficientemente clara para verificar el documento",
  V4009: "Falta una cara o página requerida del documento.",
  V4010: "Tipo de documento no soportado.",
  V4999: "Ocurrió un error inesperado durante la verificación.",
  V999: "Ocurrió un error inesperado durante la verificación.",
};
